import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Container, Fab, Tooltip, Backdrop } from "@material-ui/core";
import { Link, useHistory, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
import useStyles from "./styles";
import SiteCreate from "./site.create";
import { useFetchSites } from "../../hooks/useFetchEntities";
import Spinner from "../../components/Common/Spinner";

function Sites() {
  const history = useHistory();
  const classes = useStyles();
  const [sites, fetched] = useFetchSites();
  const [loading, setLoading] = useState(false);
  const [showAdminOptions, setShowAdminOptions] = useState(false);

  let user = useSelector((state) => state.user);

  const onRowClick = (rowData, rowMeta) => {
    history.push("/site/manage/" + rowData[0]);
  };

  useEffect(() => {
    user && setShowAdminOptions(user.isAdmin);
  }, [user]);

  useEffect(() => {
    setLoading(!fetched);
  }, [fetched]);

  const gridOptions = {
    fixedHeader: true,
    tableBodyMaxHeight: "60vh",
    filterType: "multiselect",
    selectableRows: "none",
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    onRowClick: onRowClick,
    print: false,
    download: false,
    storageKey: "sites-table",
  };

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "number",
      label: "Site Code",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "countryName",
      label: "Country",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "tierName",
      label: "Tier",
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  return (
    <div style={{ marginRight: 32 }}>
      {showAdminOptions && (
        <Tooltip title="Add" aria-label="add">
          <Fab color="primary" aria-label="add" className={classes.createFab} component={Link} to={"/sites/create"}>
            <AddIcon />
          </Fab>
        </Tooltip>
      )}
      {!loading && (
        <MUIDataTable
          title={"Sites"}
          data={sites && sites.filter((s) => !s.isOther)}
          columns={gridColumns}
          options={gridOptions}
        />
      )}
      <Route path="/sites/create">
        <SiteCreate />
      </Route>
      <Spinner show={loading} />
    </div>
  );
}

export default Sites;
